import React, { useEffect, useState } from 'react';
import { useAppSelector } from '../../../hooks/hooks';
import MainBar from './MainBar';
import MobileBar from './MobileBar';
import TopBar from './TopBar';

type PropsType = {
  className?: string;
  drawerAction: () => void;
  events: {
    id: number;
    name: string;
  }[];
};

const Header = ({ className, drawerAction, events }: PropsType) => {
  const user = useAppSelector((state) => state.profile.user);
  const [stuck, setStuck] = useState(false);

  /* The utility strip scrolls away; the nav bar stays and gains a shadow. */
  useEffect(() => {
    const onScroll = () => setStuck(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`${className || ''} relative z-40`}>
      <TopBar className='print:hidden' />
      <div
        className={`sticky top-0 z-40 transition-shadow duration-300 ${
          stuck ? 'shadow-raise' : ''
        }`}
      >
        <MainBar isAuth={!!user} name={user?.name} events={events} />
        <MobileBar isAuth={!!user} drawerAction={drawerAction} />
      </div>
    </header>
  );
};

export default Header;
